import { render, staticRenderFns } from "./RoutingGroupList.vue?vue&type=template&id=24e2f3c1&"
import script from "./RoutingGroupList.vue?vue&type=script&lang=js&"
export * from "./RoutingGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports